import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { isGlobalViewsWebsite, isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { ProductListFilterState } from "@tSurya/Store/Data/SurProductListHideAndShowFilterState";
import { Draft } from "immer";

const getInitialFilterState = (): boolean => {
    if (typeof window === "undefined") {
        return false;
    }

    // Filters start hidden (collapsed) on Global Views and MGBW websites.
    return isGlobalViewsWebsite() || isMgbwWebsite();
};

const initialState: ProductListFilterState = {
    filterData: getInitialFilterState(),
};

const reducer = {
    "Custom/ProductList/SetFilterValue": (draft: Draft<ProductListFilterState>, action: { result: boolean }) => {
        draft.filterData = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
